import { Link } from "react-router-dom";
import { MoveRight, Star } from "lucide-react";

const reviews = [
  {
    name: "Priya Sharma",
    meta: "Modular kitchen · Mumbai",
    text: "The PU finish on our kitchen shutters is flawless — smooth, deep in colour and easy to clean. Friends assume it was imported. The design team listened to every small requirement before a single panel was cut.",
  },
  {
    name: "Rahul Mehta",
    meta: "Full home furniture · Thane",
    text: "Truly professional from the first site visit to final installation. The wardrobes, TV unit and kitchen were delivered faster than promised, and the fitting team left the home spotless. Rare discipline in this industry.",
  },
  {
    name: "Anita Desai",
    meta: "Personalized wardrobe · Vasai",
    text: "Polite staff, honest pricing and top-notch material quality. They explained every finish option patiently and never pushed the expensive one. Our solidwood wardrobe feels built for generations.",
  },
  {
    name: "Vikram Jain",
    meta: "TV unit & storage · Mumbai",
    text: "You can see the German machinery in the details — not a single chip-off or rough edge anywhere. The media wall they built has become the most photographed corner of our home.",
  },
  {
    name: "Sneha Kulkarni",
    meta: "Modular kitchen · Palghar",
    text: "We compared three big brands before choosing Innovation. Better material, better finish and far better value. Two years of daily cooking later, the kitchen still looks brand new.",
  },
  {
    name: "Arjun Nair",
    meta: "Office cabinetry · Virar",
    text: "They handled our office storage like a bespoke home project — measured twice, delivered early, installed quietly over a weekend. The most dependable manufacturing partner we have worked with.",
  },
];

function Stars() {
  return (
    <div className="stars" aria-label="5 star rating">
      {[0, 1, 2, 3, 4].map((i) => <Star key={i} size={14} fill="currentColor" strokeWidth={0} />)}
    </div>
  );
}

export function TestimonialsPage() {
  return (
    <div data-testid="testimonials-page">
      <section className="page-hero">
        <div className="page-hero-copy">
          <span className="eyebrow">Voices of our patrons</span>
          <h1>Homes that speak<br /><i>for us.</i></h1>
          <p>Over 12,000 projects a year leave our Vasai factory — but the measure of our work is what families say after living with it. Here is what our patrons share on Google.</p>
          <Link to="/contact" className="button" data-testid="page-primary-cta">Start your story <MoveRight size={17} /></Link>
        </div>
        <img className="page-hero-portrait" src="https://customer-assets-0z36b82j.emergentagent.net/job_modular-excellence/artifacts/uox6xce8_IMG_6819.jpg" alt="A finished Innovation Modular System living room with marble media wall" />
      </section>
      <section className="rating-band" data-testid="rating-summary">
        <div className="rating-number">4.6</div>
        <div>
          <Stars />
          <p className="rating-note">Based on 53 Google reviews for Innovation Modular System, Vasai-Virar — across kitchens, wardrobes, TV units and full-home projects.</p>
        </div>
      </section>
      <section className="content-section">
        <div>
          <span className="eyebrow">In their words</span>
          <h2>Real homes.<br /><i>Real words.</i></h2>
          <div className="review-grid">
            {reviews.map((r, i) => (
              <article className="review-card" key={r.name} data-testid={`review-card-${i + 1}`}>
                <Stars />
                <blockquote>“{r.text}”</blockquote>
                <div className="review-meta">
                  <b>{r.name}</b>
                  <span>{r.meta}</span>
                  <span className="review-tag">Google review</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
